import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingButtons } from './components/FloatingButtons';
export function App() {
  return <div className="min-h-screen bg-primary text-white font-sans selection:bg-gold selection:text-primary" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Stats data-id="element-4" />
        <Services data-id="element-5" />
        <BeforeAfter data-id="element-6" />
        <WhyUs data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Contact data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <FloatingButtons data-id="element-11" />
    </div>;
}